var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 69,
    viewBox: "0 0 60 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#ECF6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_4821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8887 31.125C14.8942 35.9249 17.1422 43.3748 19.0154 46.4998C21.6393 43.1248 23.138 41.9998 25.0113 40.4999C25.1361 38.4999 23.887 34.125 20.8887 31.125Z",
    fill: "#9FD2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1152 31.126C45.1097 35.9259 42.8618 43.3758 40.9885 46.5007C38.3646 43.1258 36.8659 42.0008 34.9927 40.5008C34.8678 38.5009 36.1169 34.1259 39.1152 31.126Z",
    fill: "#9FD2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7334 6.00098C29.7643 6.01292 39.4746 9.77808 39.4746 26.626C39.4745 33.6018 35.8193 39.7676 32.9873 43.5H26.4795C23.6475 39.7676 19.9923 33.6019 19.9922 26.626C19.9922 9.75123 29.7334 6.00098 29.7334 6.00098ZM29.7393 17.249C27.6701 17.249 25.9922 18.928 25.9922 20.999C25.9924 23.0699 27.6702 24.749 29.7393 24.749C31.8081 24.7488 33.4851 23.0697 33.4854 20.999C33.4854 18.9281 31.8082 17.2493 29.7393 17.249Z",
    fill: "#9FD2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6982 46.5C26.3935 48.8172 28.5953 50.6036 29.7343 51.207V51.208C30.8733 50.6046 33.075 48.8182 32.7704 46.501C33.782 47.1044 35.2744 49.0353 33.1503 51.9316C31.0259 54.8281 29.9877 56.5182 29.7343 57.001V57C29.4809 56.5172 28.4426 54.8272 26.3183 51.9307C24.1942 49.0343 25.6866 47.1034 26.6982 46.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.7388,
    cy: 20.999,
    rx: 3.74659,
    ry: 3.74994,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_4821",
    x: 9,
    y: 2.00098,
    width: 42.0039,
    height: 67,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160784 0 0 0 0 0.564706 0 0 0 0 0.984314 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4821"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4821",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.7ebecaeab8754451b3dcef8495e62782.svg";
export { ForwardRef as ReactComponent };